import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import * as Cookies from "js-cookie";
import Swal from 'sweetalert2';
import storage from "../../../Storage";
import { encode } from "../../../Helper";
import socket from "../../../Socket";
import C from "../../../Constant";

import { Modal } from "react-bootstrap";

class Logout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false
        };
        this.ask = this.ask.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.confirmLogout = this.confirmLogout.bind(this);
    }

    ask() {
        this.setState({ show: true });
    }

    handleClose() {
        this.setState({ show: false });
    }

    confirmLogout() {
        socket.emit(C.LOGOUT_USER, encode({ token: storage.getKey('token') }));
        localStorage.clear();
        Cookies.remove("session");
        Cookies.remove("auth");
        Cookies.remove("uid");
        window.location.replace('./');
    }

    render() {
        return (
            <>
                <button onClick={this.ask} className={"dropdown-item p-0"} style={{ marginTop: '2px' }}>
                    <i className="mdi mdi-power text-danger mr-1 text-drop" />
                </button>

                <Modal
                    size="sm"
                    centered={true}
                    show={this.state.show}
                    onHide={this.handleClose}
                    className="auth-modal-custom animated zoomIn"
                >
                    <Modal.Body className="p-0">
                        <div className="auth-form-container text-center py-5">
                            <div className="mb-4">
                                <i className="mdi mdi-power text-danger" style={{ fontSize: '64px', filter: 'drop-shadow(0 0 15px rgba(239, 68, 68, 0.4))' }} />
                            </div>
                            <h4 className="text-white font-weight-bold mb-2">Logout</h4>
                            <p className="text-white opacity-70 mb-5 px-3">Are you sure you want to log out of your account?</p>

                            <div className="d-flex flex-column gap-3 px-2">
                                <button className="btn btn-danger-gradient py-3" onClick={this.confirmLogout}>
                                    Log Out
                                </button>
                                <button className="btn btn-link text-white opacity-50 font-weight-bold" onClick={this.handleClose} style={{ textDecoration: 'none' }}>
                                    Stay Logged In
                                </button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </>
        );
    }
}

export default withRouter(Logout);